import api from "./axiosInstance";
import networkConfig from "../utils/networkConfig";

export const getWheelItems = async () => {
  // const res = await api.get("/api/wheel");
  const res = await api.get(networkConfig.spinWheel.spinWheel);
  return res.data;
};

export const updateWheelItem = async (id, payload) => {
  const res = await api.patch(`/api/wheel/${id}`, payload);
  return res.data;
};
